import { reviews } from "../data";

export default function ReviewSlider() {
  // Vi tripler anmeldelserne for at sikre en fuldstændig sømløs rullende effekt uden huller
  const duplicatedReviews = [...reviews, ...reviews, ...reviews];

  return (
    <div className="relative w-full overflow-hidden py-6">
      {/* Bløde gradients i siderne for at tone kortene ud */}
      <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-16 bg-gradient-to-r from-[#fcfbf9] to-transparent md:w-32" />
      <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-16 bg-gradient-to-l from-[#fcfbf9] to-transparent md:w-32" />

      <div className="flex w-full">
        <div className="animate-infinite-scroll flex gap-6">
          {duplicatedReviews.map((review, index) => (
            <div
              key={`${review.id}-${index}`}
              className="
                w-[calc(100vw-32px)] sm:w-[340px] md:w-[360px] lg:w-[368px]
                shrink-0 rounded-2xl border border-stone-200 bg-white p-6 shadow-xs
                flex flex-col justify-between transition-all duration-300
              "
            >
              <div>
                <div className="flex items-center gap-1 text-brand-orange">
                  {[...Array(review.rating)].map((_, i) => (
                    <i key={i} className="fa-solid fa-star text-sm" />
                  ))}
                </div>
                <p className="mt-4 text-sm leading-relaxed text-stone-600 md:text-base italic">
                  "{review.text}"
                </p>
              </div>
              <div className="mt-6 flex items-center justify-between border-t border-stone-100 pt-4">
                <div>
                  <h4 className="text-sm font-bold text-brand-stone-dark md:text-base">
                    {review.name}
                  </h4>
                  <p className="text-xs text-stone-400">{review.location}</p>
                </div>
                <span className="text-xs text-stone-400 font-medium">{review.date}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
